import React, { useState, useEffect, useRef } from "react";
import { Box, Button, TextField, Typography, Grid, Autocomplete } from "@mui/material";
import Heading from "../heading";
import CtaButton from "../buttonWithArrow";
import { useDispatch, useSelector } from "react-redux";
import {
    getContactInfo, clearGetContactInfo
} from "../../redux/slices/product";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import PhoneInput from "../phoneInput";


export default function ContactEnquiry() {
    const dispatch = useDispatch();
    const { contactInfoRes } = useSelector((state) => state.product);
    const buttonRefs = useRef({});
    const [selectedType, setSelectedType] = useState("Others");
    const [alertOpen, setAlertOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [alertImage, setAlertImage] = useState("");
    const [alertTitle, setAlertTitle] = useState("");
    const [loader, setLoader] = useState(false);

    const [datas, setDatas] = useState({
        name: "",
        email: "",
        countryCode: "+971",
        phone: "",
        subject: "",
        description: "",
        type: ""
    });

    const [errors, setErrors] = useState({});

    const enquiryTypes = [
        "Corporate Enquiry",
        "Franchise Enquiry",
        "Supplier Enquiry",
        "Others",
    ];

    const getTypeNumber = (label) => {
        switch (label) {
            case "Corporate Enquiry":
                return 1;
            case "Franchise Enquiry":
                return 2;
            case "Supplier Enquiry":
                return 3;
            case "Others":
                return "";
            default:
                return 1;
        }
    };

    useEffect(() => {
        if (contactInfoRes) {
            setLoader(false);
            setMessage(contactInfoRes?.message);
            setAlertOpen(true);
            if (contactInfoRes?.status === 1) {
                setAlertTitle("Thank You!");
                setAlertImage("/icon/greenTick.png");
            } else {
                setAlertImage("/icon/reject.png");
                setAlertTitle("Something went wrong")
            }
        }
    }, [contactInfoRes]);


    console.log("datas", datas);


    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const type = queryParams.get("type");

        switch (type) {
            case "1":
                setSelectedType("Corporate Enquiry");
                break;
            case "2":
                setSelectedType("Franchise Enquiry");
                break;
            case "3":
                setSelectedType("Supplier Enquiry");
                break;
            case "":
                setSelectedType("Others");
                break;
            default:
                setSelectedType("Others");
        }

        setDatas({ ...datas, type: parseInt(type) })

    }, [location.search]);


    const handleClose = () => {
        setAlertOpen(false);
        setMessage("");
        setDatas({
            name: "",
            email: "",
            phone: "",
            type: "",
            subject: "",
            description: "",
        });
        setErrors({});
        dispatch(clearGetContactInfo());
    };



    const validate = () => {
        const newErrors = {};

        if (!datas.name.trim()) newErrors.name = "Name is required";
        if (!datas.email.trim()) {
            newErrors.email = "Email is required";
        } else if (!/\S+@\S+\.\S+/.test(datas.email)) {
            newErrors.email = "Enter a valid email address";
        }

        if (!datas.phone.trim()) {
            newErrors.phone = "Phone number is required";
        } else if (!/^\d{6,15}$/.test(datas.phone)) {
            newErrors.phone = "Enter a valid phone number";
        }

        // subject & description optional for type 1, 2, 3
        if (![1, 2, 3].includes(datas.type)) {
            if (!datas.subject.trim()) newErrors.subject = "Subject is required";
            if (!datas.description.trim())
                newErrors.description = "Description is required";
        }

        return newErrors;
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        setErrors({});
        setLoader(true);

        const obj = {
            name: datas?.name,
            email: datas?.email,
            countryCode: datas?.countryCode || "+971",
            mobile: datas?.phone,
            subject: datas?.subject,
            description: datas?.description,
            type: datas?.type
        };
        dispatch(getContactInfo(obj));
    };



    const handleChange = (field, value) => {
        setDatas((prev) => ({ ...prev, [field]: value }));
        if (errors[field]) setErrors((prev) => ({ ...prev, [field]: "" }));
    };

    useEffect(() => {
        const el = buttonRefs.current[selectedType];
        if (el) {
            el.scrollIntoView({
                behavior: "smooth",
                inline: "center",
                block: "nearest",
            });
        }
    }, [selectedType]);

    return (
        <>
            <Box style={{ backgroundColor: "#f9f9f9", paddingTop: 20 }}>
                <Heading title="Still have any query ? " subtitle="Make journey comfortable with" mb={1} />
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 6,
                        px: 6,
                        py: 4,
                        flexWrap: "wrap",
                    }}
                >
                    {/* Left Side - Image + Title */}
                    <Box sx={{ flex: "1 1 400px", textAlign: "left" }}>

                        <Box
                            component="img"
                            src={`${process.env.IMAGE_BASE_URL}/images/bannerImage/1761399917816.svg`}
                            alt="Contact Icon"
                            sx={{
                                width: "380px",
                                maxWidth: "100%",
                                display: "block",
                                mx: "auto",
                            }}
                        />
                    </Box>

                    {/* Right Side - Form */}
                    <Box
                        sx={{
                            flex: "1 1 500px",
                            display: "flex",
                            flexDirection: "column",
                            gap: 1,
                        }}
                    >
                        <Typography variant="subtitle" sx={{ fontWeight: 600 }}>
                            I’m interested in...
                        </Typography>

                        <Box
                            sx={{
                                display: "flex",
                                flexWrap: "nowrap",
                                gap: 1,
                                overflowX: "auto",
                                pb: 1,
                            }}
                        >
                            {enquiryTypes.map((type) => (
                                <Button
                                    key={type}
                                    ref={(el) => (buttonRefs.current[type] = el)}
                                    variant={selectedType === type ? "contained" : "outlined"}
                                    onClick={() => {
                                        setSelectedType(type);
                                        setDatas((prev) => ({
                                            ...prev,
                                            type: getTypeNumber(type),
                                        }));
                                    }}
                                    sx={{
                                        flexShrink: 0,
                                        borderRadius: "50px",
                                        border:
                                            selectedType === type
                                                ? "1px solid #009090"
                                                : "1px solid #00000066",
                                        textTransform: "none",
                                        px: 2,
                                        backgroundColor:
                                            selectedType === type ? "#00a6a6" : "transparent",
                                        color: selectedType === type ? "#fff" : "#00000066",
                                        "&:hover": {
                                            border: "1px solid #009090",
                                            backgroundColor:
                                                selectedType === type
                                                    ? "#009090"
                                                    : "rgba(0,0,0,0.05)",
                                        },
                                    }}
                                >
                                    {type}
                                </Button>
                            ))}
                        </Box>


                        <Box
                            sx={{
                                display: "grid",
                                gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" }, // 1 per row on mobile, 2 per row on md+
                                gap: 1,
                            }}
                        >
                            <Box>
                                <Typography sx={{ fontWeight: 600 }}>Name</Typography>
                                <TextField
                                    placeholder="Enter Full Name"
                                    fullWidth
                                    variant="outlined"
                                    value={datas.name}
                                    name="name"
                                    onChange={(e) => handleChange(e.target.name, e.target.value)}
                                    error={Boolean(errors.name)}
                                    helperText={errors.name}
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: "50px",
                                            backgroundColor: "#fff",
                                        },
                                    }}
                                />
                            </Box>

                            <Box>
                                <Typography sx={{ fontWeight: 600 }}>Email</Typography>
                                <TextField
                                    placeholder="Enter Your Email"
                                    fullWidth
                                    variant="outlined"
                                    value={datas.email}
                                    name="email"
                                    onChange={(e) => handleChange(e.target.name, e.target.value)}
                                    error={Boolean(errors.email)}
                                    helperText={errors.email}
                                    sx={{
                                        "& .MuiOutlinedInput-root": {
                                            borderRadius: "50px",
                                            backgroundColor: "#fff",
                                        },
                                    }}
                                />
                            </Box>
                        </Box>


                        <Box>
                            <Typography sx={{ fontWeight: 600 }}>Contact Number</Typography>

                            <Grid item xs={12} sm={6} display="flex">
                                {/* Country Code Selector */}
                                {/* <Autocomplete
                                disableClearable
                                options={countries}
                                getOptionLabel={(option) => `${option.code} (+${option.phone})`}
                                value={
                                    countries.find((c) => c.phone === datas?.countryCode) || countries[1]
                                }
                                onChange={(e, value) =>
                                    setDatas((prev) => ({
                                        ...prev,
                                        countryCode: value.phone,
                                    }))
                                }
                                sx={{
                                    width: "35%",
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: "50px 0 0 50px",
                                        backgroundColor: "#fff",
                                        // height: "46px",
                                        "& fieldset": { borderColor: "#ccc" },
                                        "&:hover fieldset": { borderColor: "#999" },
                                        "&.Mui-focused fieldset": { borderColor: "#1976d2" },
                                    },
                                    "& .MuiInputBase-input": {
                                        fontSize: 15,
                                        pl: 2,
                                    },
                                }}
                                renderInput={(params) => (
                                    <TextField {...params} variant="outlined" />
                                )}
                            /> */}

                                {/* Phone Number Input */}
                                {/* <TextField
                                fullWidth
                                placeholder="Enter phone number"
                                value={datas?.phone}
                                onChange={(e) => {
                                    const numericValue = e.target.value.replace(/\D/g, "");
                                    if (numericValue.length <= 10) {
                                        setDatas((prev) => ({ ...prev, phone: numericValue }));
                                    }

                                    if (
                                        errors.phone &&
                                        numericValue.length === 10 &&
                                        /^\d+$/.test(numericValue)
                                    ) {
                                        setErrors((prev) => ({ ...prev, phone: "" }));
                                    }
                                }}
                                inputProps={{ maxLength: 10 }}
                                error={!!errors.phone}
                                helperText={errors.phone || ""}
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: "0 50px 50px 0",
                                        backgroundColor: "#fff",
                                        // height: "46px",
                                        "& fieldset": { borderColor: "#ccc" },
                                        "&:hover fieldset": { borderColor: "#999" },
                                        "&.Mui-focused fieldset": { borderColor: "#1976d2" },
                                    },
                                    "& .MuiInputBase-input": {
                                        fontSize: 15,
                                        pl: 2,
                                    },
                                    "& .MuiFormHelperText-root": {
                                        ml: 1.5,
                                        mt: 0.5,
                                    },
                                }}
                            /> */}

                                <PhoneInput
                                    value={datas.phone}
                                    countryCode={datas.countryCode}
                                    onChange={(countryCode, phone) => {
                                        handleChange("phone", phone);
                                        handleChange("countryCode", countryCode);
                                    }}
                                    error={!!errors.phone}
                                    helperText={errors.phone}
                                    width="100%"
                                />
                            </Grid>
                        </Box>

                        <Box>
                            <Typography sx={{ fontWeight: 600 }}>Subject</Typography>
                            <TextField
                                placeholder="Enter Subject"
                                fullWidth
                                variant="outlined"
                                value={datas.subject}
                                name="subject"
                                // onChange={(e) => setDatas({ ...datas, subject: e.target.value })}
                                onChange={(e) => handleChange(e.target.name, e.target.value)}
                                error={Boolean(errors.subject)}
                                helperText={errors.subject}
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: "50px",
                                        backgroundColor: "#fff",
                                    },
                                }}
                            />
                        </Box>
                        <Box>
                            <Typography sx={{ fontWeight: 600 }}>Description</Typography>
                            <TextField
                                placeholder="Enter Description"
                                fullWidth
                                multiline
                                rows={3}
                                name="description"
                                variant="outlined"
                                value={datas.description}
                                // onChange={(e) => setDatas({ ...datas, description: e.target.value })}
                                onChange={(e) => handleChange(e.target.name, e.target.value)}
                                error={Boolean(errors.description)}
                                helperText={errors.description}
                                sx={{
                                    "& .MuiOutlinedInput-root": {
                                        borderRadius: "30px",
                                        backgroundColor: "#fff",
                                    },
                                }}
                            />
                        </Box>

                        <Box>
                            <CtaButton label="Submit" onClick={handleSubmit} disabled={loader} loader={loader} />
                        </Box>
                    </Box>
                </Box>
            </Box >
            <Dialog
                fullWidth="true"
                maxWidth="sm"
                open={alertOpen}
                onClose={handleClose}
            >
                <DialogContent>
                    <DialogContentText sx={{ textAlign: "center", fontWeight: "700" }}>
                        <Grid container spacing={3} className="flex-column">
                            <Grid
                                item
                                md={12}
                                sx={{ display: "flex", justifyContent: "center" }}
                            >
                                <img src={alertImage} alt="Success" width="100" />

                            </Grid>
                            <Grid
                                item
                                md={12}
                                sx={{ display: "flex", justifyContent: "center" }}
                            >
                                <h2>{alertTitle}</h2>
                            </Grid>
                            <Grid
                                item
                                md={12}
                                sx={{ display: "flex", justifyContent: "center" }}
                            >
                                <h5 style={{ color: "black" }}>{message}</h5>
                            </Grid>
                        </Grid>
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
                    <Box>
                        <Button onClick={handleClose} variant="contained"
                            sx={{
                                background: "linear-gradient(180deg, #7fd0cb 0%, #0f7f8a 100%)",
                                color: "#fff",
                                textTransform: "none",
                                fontWeight: 700,
                                borderRadius: "50px",
                                px: 3,
                                py: 1,
                                mb: 2,
                                boxShadow: "0px 3px 6px rgba(0,0,0,0.2)",
                                "&:hover": {
                                    background: "linear-gradient(180deg, #6cc3be 0%, #0c6e7a 100%)",
                                    boxShadow: "0px 4px 10px rgba(0,0,0,0.3)",
                                },
                            }}>
                            Okay
                        </Button>
                    </Box>
                </DialogActions>
            </Dialog>
        </>
    );
}
